
export const useScrollHandler = ({ ref }: { ref: any }): (scrollDiff: number) => void => {

    const handler = (scrollDiff) => {
        if (!ref?.current) return;
        ref.current.scrollLeft += scrollDiff;
    }
    return handler
}